import $ from "jquery";
import React, { createRef, useEffect } from "react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Text, Icon, Button, Flex } from "@chakra-ui/react";
import "./formBuilder.css";
import useSaveForm from "hooks/useSaveForm";
import useUpdateForm from "hooks/useUpdateForm";

window.jQuery = $;
window.$ = $;

require("jquery-ui-sortable");
require("formBuilder");

// var fbEditor = document.getElementById("fb-editor");
// var formBuilder = $(fbEditor).formBuilder();

/* 
The order of the imports and requires is very important, especially in the online enviornment.
The two jQuery libraries must be imported using Node's require(), and not ES6 import.
Also, these two requires MUST come after setting the global jQuery and $ symbols.

In my Babel/Webpack project, the type and order of the imports is a little less sensitive.
For my project, the following alternative works:

    import $ from 'jquery';
    import React from 'react';
    import ReactDOM from 'react-dom';
    import 'jquery-ui-sortable';

    window.jQuery = $;
    window.$ = $;

    require('formBuilder');
*/

const FormBuilder = ({ setShowFormFields, formData }) => {
  const fb = createRef();
  const newData = [];
  useEffect(() => {
    $(fb.current).formBuilder({ formData });
    window.scrollTo(0, 0);
  }, []);
  const { mutate: saveForm } = useSaveForm();
  const { mutate: updateForm } = useUpdateForm();

  const getKeyByValue = (data) => {
    Object.keys(data).forEach((key) => {
      if (data[key].formBuilder) {
        const apiData = [];
        const array = data[key].formBuilder.actions.getData();
        array.map((arr) => {
          const { label, type, multiple, values, ...rest } = arr;
          apiData.push({ label, type, multiple, values, properties: rest });
        });

        saveForm(apiData);
      }
    });
  };

  const handleSave = () => {
    var $fbEditor = $(document.getElementById("fb-editor"));
    getKeyByValue($fbEditor[0]);
  };

  return (
    <Box
      w="100%"
      className="form-Builder btn-group"
      pt={{ base: "130px", md: "80px", xl: "80px" }}
      mb="60px"
      h="max-content"
      position="relative"
    >
      <Flex align="center" pb="20px">
        <div
          onClick={() => setShowFormFields(false)}
          style={{ cursor: "pointer" }}
        >
          <Icon as={ArrowBackIcon} w={6} h={6} />
        </div>
        <Text fontSize={"26px"} color="#2B3674" fontWeight="bold" ml="20px">
          Entity Meta Fields
        </Text>
      </Flex>
      <div id="fb-editor" ref={fb} />
      <Flex mt="20px">
        {formData?.length > 0 ? (
          <Button
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="20%"
            h="50"
            mb="24px"
            mr="20px"
            onClick={handleSave}
          >
            Save
          </Button>
        ) : (
          <Button
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="20%"
            h="50"
            mb="24px"
            mr="20px"
            onClick={handleSave}
          >
            Create
          </Button>
        )}
        <Button
          fontSize="sm"
          variant="brand"
          fontWeight="500"
          w="20%"
          h="50"
          mb="24px"
          mr="20px"
          onClick={() => setShowFormFields(false)}
        >
          Cancel
        </Button>
      </Flex>
    </Box>
  );
};

export default FormBuilder;
